import AOS from 'aos'
import domReady from './js/utils/domReady.js'
import './app.scss'

import './js/theme/forms.js'
import './js/theme/locationViewer.js'
import './js/theme/magnific.js'
import './js/theme/nav.js'
import './js/theme/notification.js'
import './js/theme/rellax.js'
import './js/theme/social-actions.js'
import './js/theme/events-viewer/main.js'
import './js/theme/site.js'

// Component library JS
import '@lib/components/04-content-blocks/slideshow/slideshow.js'
import '@lib/components/04-content-blocks/events-feed/events-feed.js'
import '@lib/components/04-content-blocks/testimonial-carousel/testimonial-carousel.js'

domReady(function () {
  AOS.init()
})
